export default "__VITE_ASSET__Ddobc_gB__"